import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import {fetchInsiderAttackOptions} from "../../../actions";
import RequestAttackOptionsDialog from "../controllers/RequestAttackOptionsDialog";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const colorFunction = (stateData) => {
        return "light";
    }

    const valueFunction = (stateData) => stateData ? Object.keys(stateData).length : null;

    return (
        <DataTile
            // color = {colorFunction()}
            colorBgFunction={colorFunction}
            subTitle="Attack Options"
            tipText={`The Insider Threat module is self-directed. Use the menu of options to launch attacks against single hosts or specified enclaves.`}
            icon={<RequestAttackOptionsDialog
                iconOnly
                iconSize={"70px"}/>
            }//<BBIconRocketSharpAdd style={{fontSize: "70px"}}/>
            stateName="insider"
            stateElement="attackPackages"
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            stateLoaderName="loadingAttackPackages"
            stateLoaderError="loadingAttackPackagesFail"
            stateFetchAction={fetchInsiderAttackOptions()}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={null}
            requiresModule={"insider"}
        />
    )

}

export default Tile;